import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import ScrollFloat from "../component/ScrollFloat";
import { useTheme } from "../ThemeContext";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";
import { motion } from "framer-motion";
import "swiper/css";

export default function BlockchainDevelopment() {
  // const { theme } = useTheme();
  const coinImages = [
    "assets/images/coin/coin_01.png",
    "assets/images/coin/coin_02.png",
    "assets/images/coin/coin_03.png",
    "assets/images/coin/coin_04.png",
    "assets/images/coin/coin_05.png",
    "assets/images/coin/coin_06.png",
    "assets/images/coin/coin_07.png",
    "assets/images/coin/coin_08.png",
    "assets/images/coin/coin_09.png",
    "assets/images/coin/coin_10.png",
    "assets/images/coin/coin_11.png",
    "assets/images/coin/coin_12.png",
  ];

  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const currentTheme =
      document.documentElement.getAttribute("data-theme") || "light";
    setTheme(currentTheme);

    const observer = new MutationObserver(() => {
      const newTheme =
        document.documentElement.getAttribute("data-theme") || "light";
      setTheme(newTheme);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  const industries = [
    {
      title: "Healthcare",
      iconLight: "assets/images/blockchain/health-light.svg",
      iconDark: "assets/images/blockchain/health-dark.svg",
    },
    {
      title: "Real Estate",
      iconLight: "assets/images/blockchain/estate-light.svg",
      iconDark: "assets/images/blockchain/estate-dark.svg",
    },
    {
      title: "BFSI",
      iconLight: "assets/images/blockchain/bank-light.svg",
      iconDark: "assets/images/blockchain/bank-dark.svg",
    },
    {
      title: "Logistics",
      iconLight: "assets/images/blockchain/truck-light.svg",
      iconDark: "assets/images/blockchain/truck-dark.svg",
    },
    {
      title: "Retail",
      iconLight: "assets/images/blockchain/retail-light.svg",
      iconDark: "assets/images/blockchain/retail-dark.svg",
    },
    {
      title: "Entertainment",
      iconLight: "assets/images/blockchain/tv-light.svg",
      iconDark: "assets/images/blockchain/tv-dark.svg",
    },
    {
      title: "Education",
      iconLight: "assets/images/blockchain/education-light.svg",
      iconDark: "assets/images/blockchain/education-dark.svg",
    },
    {
      title: "Energy",
      iconLight: "assets/images/blockchain/energy-light.svg",
      iconDark: "assets/images/blockchain/energy-dark.svg",
    },
  ];

  const splitTextToSpans = (text, className = "") =>
    [...text].map((char, index) => (
      <span className={`char ${className}`} key={`${char}-${index}`}>
        {char === " " ? "\u00A0" : char}
      </span>
    ));
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <>
      <Helmet>
        <title>Blockchain Development Services | Blockcryp Experts</title>
        <meta
          name="description"
          content="Build secure, scalable blockchain solutions with Blockcryp. We specialize in smart contracts, DeFi, NFTs, crypto exchanges, and custom blockchain development."
        />
        <meta
          name="keywords"
          content="blockchain development services, custom blockchain solutions, smart contract development, DeFi development company, NFT marketplace development, crypto exchange development, Web3 development company, enterprise blockchain solutions, blockchain consulting services, decentralized app development"
        />
      </Helmet>
      {/* ---------- hreo section start ---------- */}
      <section className="token_hero space80">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-1 order-2">
              <motion.h1
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h1 fw-bold"
              >
                Blockchain Development Company
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt"
              >
                In blockchain development – Blockcryp remove add Blockcryp
                complex blockchain dreams into real-world breakthroughs. As a
                trend-setting <b> Blockchain Development Company,</b> our
                comprehensive blockchain solutions are crafted to move
                industries forward and leverage blockchain technology as a
                competitive edge. Decentralization starts with us, and it’s your
                turn to step into the Web3 ecosystem with <b>Blockcryp.</b>
              </motion.p>

              <motion.button
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="button theme_btn mt-lg-4 mt-0"
                type="submit"
              >
                Talk to Our Expert
              </motion.button>
            </div>
            <div className="col-lg-6 order-lg-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/blockchain/block_hero3.webp"
                  alt="token hero"
                  className="w-100"
                />
                {/* <img
                  src="assets/images/blockchain/block_hero11.webp"
                  alt="token hero"
                  className="w-100"
                /> */}
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* ------------------  blochchain about section start ---------------- */}
      <section className="space80">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-6 text-center">
              {/* <motion.img
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                src="assets/images/blockchain/web33.webp"
                alt="blockchain"
                className="about_block w-100"
              /> */}
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/blockchain/web4.webp"
                  alt="blockchain"
                  className="about_block w-100"
                />
              </motion.div>
            </div>
            <div className="col-lg-6">
              <motion.h3
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="fw-bold mb-3 heading_h4 lh-base"
              >
                Blockchain Development Solutions: Building a Scalable Future in
                the Web3 Economy
              </motion.h3>
              <motion.p
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt"
              >
                As consumer demand for sustainability rises, blockchain
                technology is essential for verifying ethical practices and
                enhancing security, efficiency, transparency, and compliance
                across various business operations. Blockcryp stands out as a
                premier blockchain development company, having completed over
                1,000 projects since its inception. Our seasoned team of
                blockchain app development experts excels in crafting
                tailor-made custom blockchain development solutions for
                businesses of all sizes across the globe.
              </motion.p>
            </div>
          </div>
        </div>
      </section>

      {/* ------------------  blochchain about section start ---------------- */}
      <section className="space80">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-1 order-2">
              <motion.h3
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="fw-bold mb-3 heading_h4 lh-base"
              >
                Blockchain Market Forecast: Growth Projections and Opportunities
                Ahead
              </motion.h3>
              <motion.ul
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className=""
              >
                <li className="mb-3">
                  Blockchain technology market is estimated to amount to nearly
                  1,000 trillion U.S. dollars by 2032.
                </li>
                <li className="mb-3">
                  The cryptocurrency market is anticipated to have approximately
                  861 million users by 2025.
                </li>
                <li className="mb-3">
                  The user penetration rate in the crypto market is expected to
                  rise to 11.02% by 2025.
                </li>
                <li className="mb-3">
                  On a global scale, the United States is estimated to generate
                  the highest revenue, reaching US$9,788 million in 2024.
                </li>
                <li className="mb-3">
                  The average revenue per user in the cryptocurrency market is
                  expected to be US$66.1 by the end of 2024
                </li>
              </motion.ul>
            </div>
            <div className="col-lg-6 order-lg-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/blockchain/growth33.webp"
                  alt="blockchain"
                  className="about_block w-100"
                />
              </motion.div>
              {/* <motion.img
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                src="assets/images/blockchain/growth22.webp"
                alt="blockchain"
                className="about_block w-100"
              /> */}
            </div>
          </div>
        </div>
      </section>
      {/* ------------------  blochchain about section start ---------------- */}

      {/* ---------- Under One Roof section start ---------- */}
      <section className="space80 services">
        <div className="container">
          <div className="row g-4">
            <div className="col-12 mt-0 mb-3">
              <ScrollFloat
                animationDuration={1}
                ease="back.inOut(2)"
                scrollStart="center bottom+=50%"
                scrollEnd="bottom bottom-=40%"
                stagger={0.09}
                textClassName="heading_h3 fw-semibold text-center"
              >
                <>
                  {splitTextToSpans("Benefits", "text-primary")}
                  {splitTextToSpans(" of Working With  Us ")}
                </>
              </ScrollFloat>

              {/* <p className="text-center">Check out web 3.0 development offerings and choose the one that best fits your business requirements.</p> */}
            </div>
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <h5 className="heading_h5 fw-semibold mb-3">
                  Protocol Expertise
                </h5>
                <p>
                  We develop on Ethereum, Hyperledger, Solana, and custom
                  chains, selecting the most suitable protocol to align with
                  your project’s unique goals, ensuring optimized performance
                  and long-term success.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <h5 className="heading_h5 fw-semibold mb-3">
                  Scalable Architecture
                </h5>
                <p>
                  Our Blockchain Development Solutions are modular, flexible,
                  and performance-optimized, capable of scaling effortlessly as
                  your business grows, ensuring reliability and efficiency.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <h5 className="heading_h5 fw-semibold mb-3">
                  Smart Integration
                </h5>
                <p className="mb-0">
                  We integrate blockchain with existing systems via APIs and
                  oracles, enabling seamless connectivity and unlocking enhanced
                  value from decentralized technologies within your current
                  operations.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <h5 className="heading_h5 fw-semibold mb-3">Audit Assurance</h5>
                <p className="mb-0">
                  Security is our priority. Every contract undergoes rigorous
                  auditing to eliminate vulnerabilities, foster trust, and
                  ensure compliance with technical standards and regulatory
                  frameworks.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <h5 className="heading_h5 fw-semibold mb-3">Token Strategy</h5>
                <p className="mb-0">
                  We design strategic tokenomics, governance, and utility models
                  that support your ecosystem, ensuring functional, valuable,
                  and sustainable token behavior across real-world and digital
                  environments.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <h5 className="heading_h5 fw-semibold mb-3">Agile Execution</h5>
                <p className="mb-0">
                  Our agile approach ensures rapid development with continuous
                  feedback, allowing flexible iterations that align with
                  shifting requirements and speed up the delivery of reliable
                  blockchain solutions.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- serve section start ---------- */}
      <section className="main_serve space80">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-12">
              <ScrollFloat
                animationDuration={1}
                ease="back.inOut(2)"
                scrollStart="center bottom+=50%"
                scrollEnd="bottom bottom-=40%"
                stagger={0.09}
                textClassName="heading_h3 fw-semibold text-center"
              >
                <>
                  {splitTextToSpans("Industries We ")}
                  {splitTextToSpans("Serve", "text-primary")}
                </>
              </ScrollFloat>

              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt text-center"
              >
                Blockcryp commitment to excellence ensures robust, future-ready
                solutions that meet industry-specific demands.
              </motion.p>
            </div>
          </div>
          <div className="serve_section my-4">
            <div className="row">
              {industries.map((item, index) => (
                <div
                  className="col-md-3 col-sm-6 col-12 text-center"
                  key={index}
                >
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className=" mb-4 p-4"
                  >
                    <div className="mb-3">
                      <img
                        src={theme === "dark" ? item.iconDark : item.iconLight}
                        alt={item.title}
                      />
                    </div>
                    <h5>{item.title}</h5>
                  </motion.div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* ---------- serve section end ---------- */}

      {/* -----------  support platform start ----------- */}
      <section className="space60">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-12 ">
              <div className="support_slider space60 border_xl p-4 p-md-5">
                <div className="text-center">
                  <motion.h2
                    initial={{ opacity: 0, y: -50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="heading_h3 fw-bold text-light mb-4"
                  >
                    Blockchain Development Platforms <br></br>{" "}
                    <span className="text-primary"> We Support </span>
                  </motion.h2>
                  <motion.p
                    initial={{ opacity: 0, y: -50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="text-white"
                  >
                    {" "}
                    As a leading custom blockchain development company, we
                    leverage different blockchain{" "}
                    <br className="d-none d-lg-block"></br>networks to provide
                    you with the best solutions aligned with your needs.
                  </motion.p>
                </div>
                <div className="space60">
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    navigation
                    loop={true}
                    autoplay={{ delay: 800, disableOnInteraction: false }}
                    speed={1000}
                    spaceBetween={20}
                    slidesPerView={6}
                    breakpoints={{
                      0: {
                        slidesPerView: 2,
                      },
                      480: {
                        slidesPerView: 3,
                      },
                      768: {
                        slidesPerView: 4,
                      },
                      1024: {
                        slidesPerView: 5,
                      },
                      1200: {
                        slidesPerView: 6,
                      },
                      1400: {
                        slidesPerView: 6,
                      },
                    }}
                  >
                    {coinImages.map((src, index) => (
                      <SwiperSlide key={index} className="text-center">
                        <img src={src} alt={`Coin Slide ${index + 1}`} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* -----------  support platform end ----------- */}

      {/* ---------- faq section start ---------- */}
      <section className="space40">
        <div className="container">
          <h2 className="heading_h3 fw-bold mb-4">
            Frequently Asked Questions
          </h2>
          <div className="row">
            <div className="col-12">
              <div className="accordion">
                <div
                  className={`accordion__item ${
                    activeIndex === 0 ? "accordion__item--active" : ""
                  }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(0)}
                  >
                    <span className="text_20 pe-4">
                      1. Is blockchain a good investment for startups?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      Yes, for startups aiming to innovate, Blockchain Software
                      Development Services offer transparency, automation, and
                      trust, especially in sectors like finance, supply chain,
                      and healthcare. It builds credibility, attracts tech-savvy
                      investors, and provides a future-ready edge. But success
                      depends on strategy, use-case relevance, and partnering
                      with the right blockchain development company.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${
                    activeIndex === 1 ? "accordion__item--active" : ""
                  }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(1)}
                  >
                    <span className="text_20 pe-4">
                      2. How long does it take to build a blockchain
                      application?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      The time to build a blockchain application varies based on
                      complexity, features, and integrations, ranging from 2 to
                      6 months. Simple apps like token creation take weeks,
                      while complex dApps with custom smart contracts require
                      more time. At our company, we prioritize speed without
                      sacrificing quality, using agile development to meet
                      deadlines efficiently. For specific projects, we offer
                      blockchain application development services that aim to
                      build software within 15 days.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${
                    activeIndex === 2 ? "accordion__item--active" : ""
                  }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(2)}
                  >
                    <span className="text_20 pe-4">
                      3. What should I look for in a blockchain development
                      partner?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      Look for a blockchain software development company with
                      proven experience, deep tech expertise, and a clear
                      understanding of your industry. They should offer
                      end-to-end services, from consultation to deployment, and
                      focus on scalable, secure solutions. Transparent
                      communication, post-launch support, and an innovative
                      mindset are key signs you’ve found the right team.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${
                    activeIndex === 3 ? "accordion__item--active" : ""
                  }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(3)}
                  >
                    <span className="text_20 pe-4">
                      4. How much do blockchain software development services
                      cost?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      Blockchain Development Services cost varies widely from
                      $20,000 to $200,000+, based on complexity, features, and
                      the type of blockchain used. A simple smart contract costs
                      less, while full-scale decentralized apps (dApps) require
                      larger investments. Customization, security, and
                      integration also impact pricing. Partnering with
                      experienced developers ensures value for every dollar
                      spent. Contact us for more pricing-related information.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${
                    activeIndex === 4 ? "accordion__item--active" : ""
                  }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 "
                    onClick={() => toggleItem(4)}
                  >
                    <span className="text_20 pe-4">
                      5. Can Blockcryp integrate existing business processes
                      with blockchain?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      Yes, our expert blockchain developers can seamlessly
                      integrate your existing business processes with
                      blockchain. Our team analyzes your current workflows,
                      identifies areas for decentralization, and designs smart
                      contracts or DApps accordingly. By connecting legacy
                      systems via APIs or private blockchains, we ensure secure,
                      scalable integration without disrupting your core
                      operations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --------------- cta start  ------------- */}
      <section className="cta space80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 ">
              <div className="text-center">
                <motion.h2
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="text_70 mb-3 text-uppercase fw-semibold talk_heading text-primary"
                >
                  Tell Us Your New Ideas
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="pera_txt"
                >
                  a dynamic design excelling in transforming imaginative
                  concepts into vivid realities through{" "}
                  <br className="d-none d-lg-block"></br> innovative strategies
                  and compelling creative executions.
                </motion.p>

                <a
                  href="https://teams.live.com/l/invite/FEAgoDJPJi4z_OT7QI"
                  target="_blank"
                >
                  <motion.button
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    type="button"
                    className="button talk_btn home_btn theme_btn mt-3"
                  >
                    let's talk <i class="fa-solid fa-square-up-right ms-2"></i>
                  </motion.button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* --------------- cta end  ------------- */}
    </>
  );
}
